import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  setItem<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem<T>(key: string): T {
    const data: string | null = localStorage.getItem(key);

    if (data) {
      return JSON.parse(data);
    }

    return null;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
